module.exports = __webpack_public_path__ + "Roboto-MediumItalic.woff2?13ec0eb5bdb821ff4930237d7c9f943f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/MediumItalic/Roboto-MediumItalic.woff2?v=2.137
// module id = 679
// module chunks = 7